import React from 'react';
import { Content } from 'antd/lib/layout/layout';
import { Col, Row } from 'antd';
import { iban as ibanValidator } from '@lemoncode/fonk-iban-validator';
import { Payment } from '@luckycart/xpn-types';
import { validateBIC as bicValidator } from 'ibantools';
import BankIcon from './images/bank.svg';
import PaypalIcon from './images/paypal.png';
import { InputStyled, FormItemStyled } from './RewardForm.style';
import { RadioButtonStyled, RadioGroupStyled } from './CashRewardForm.style';
import { FormikProps } from 'formik';
import { RewardFormValues } from './RewardForm';

interface Props {
  config: Payment;
  isBank: boolean;
  setIsBank: React.Dispatch<React.SetStateAction<boolean>>;
  validateRequired: (value: string) => string | undefined;
  formikProps: FormikProps<RewardFormValues>,
}
ibanValidator.setErrorMessage('Le champ doit avoir un format IBAN valide');

export const CashRewardForm: React.FunctionComponent<Props> = ({ config, isBank, setIsBank, validateRequired, formikProps }: Props) => {
  const { texts } = config;

  const validatePaypalField = (value: string): string | undefined => {
    if (!isBank) {
      return (/^(?![#$%&'*+\-/=?^_`{|}~])[\w\d!#$%&'*+\-/=?^_`{|}~]+(?:\.[\w\d!#$%&'*+\-/=?^_`{|}~]+)*@[a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*(?:\.[a-zA-Z]{2,3})+$/u)
        .test(value)
        ? undefined
        : 'Veuillez renseigner un email valide';
    }
    return undefined;
  };

  const validateIban = (value: string): string => {
    const validationResult = ibanValidator.validator({ value });
    return validationResult.message;
  };

  const validateBic = (value: string): string => {
    if (bicValidator(value).valid === false) {
      return 'Le champ doit avoir un format BIC/SWIFT valide';
    }
    return '';
  };

  return (
    <>
      <FormItemStyled
        name="firstName"
        label="Prénom"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="firstName" placeholder="Martin" />
      </FormItemStyled>
      <FormItemStyled
        name="lastName"
        label="Nom"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="lastName" placeholder="Dupont" />
      </FormItemStyled>
      <Content>
        <Row gutter={10}>
          <Col xs={24} md={24} sm={24} lg={24} xl={24}>
            <RadioGroupStyled defaultValue="bank"
              onChange={(event) => setIsBank(event.target.value === 'bank')}
            >
              <Col xs={24} sm={12} md={12} lg={12} xl={12} >
                <RadioButtonStyled
                  type="primary"
                  value="bank"
                  checked
                >
                  <img style={{ width: '16%' }} src={BankIcon} alt="bankIcon" />
                  {texts.iban}
                </RadioButtonStyled>
              </Col>
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <RadioButtonStyled
                  value="paypal"
                >
                  <img src={PaypalIcon} style={{ width: '16%' }} alt="paypalIcon" />
                  {texts.paypal}
                </RadioButtonStyled>
              </Col>
            </RadioGroupStyled>
          </Col>
        </Row>
      </Content>
      {
        isBank
          ? <>
            <FormItemStyled
              name="iban"
              label="IBAN"
              required={true}
              validate={validateIban}
              labelCol={{ span: 24 }}
              hidden={!isBank}
            >
              <InputStyled
                name="iban"
                placeholder="FR334533**************"
                onChange={(event) => {
                  formikProps.setFieldValue('iban', event.target.value.toUpperCase());
                }}
              />
            </FormItemStyled>
            <FormItemStyled
              name="bic"
              label="BIC / SWIFT"
              required={true}
              validate={validateBic}
              labelCol={{ span: 24 }}
              hidden={!isBank}
              style={{ width: '40%' }}
            >
              <InputStyled
                size="small"
                name="bic"
                placeholder="BOUSFRPPXXX"
                onChange={(event) => {
                  formikProps.setFieldValue('bic', event.target.value.toUpperCase());
                }}
              />
            </FormItemStyled>
          </>
          : <FormItemStyled
            name="email"
            label="Email"
            required={true}
            validate={validatePaypalField}
            labelCol={{ span: 24 }}
            hidden={isBank}
          >
            <InputStyled name="email" placeholder="Email" />
          </FormItemStyled>
      }
    </>
  );
};
